import React from 'react'
import PropTypes from 'prop-types'

class CertificationTypeSelect extends React.Component {
  state = {
    selectedTypeId: ''
  }

  onChange = (e) => {
    this.setState({ selectedTypeId: e.target.value })
    setTimeout(function() { this.props.newCertificationTypeCallback(this.state.selectedTypeId); }.bind(this), 300)
  }

  render() {
    const sortProperty = this.props.certificationTypes.length && this.props.certificationTypes[0].is_sai ? 'combined_group_name' : 'name'
    const certificationTypes = _.sortBy(this.props.certificationTypes, [sortProperty]);

    var certificationTypeOptions = certificationTypes.map(function(certificationType) {
      return (
        <option
          key={certificationType.id}
          value={certificationType.id}
        >
          {certificationType.is_sai ? certificationType.combined_group_name : certificationType.name}
        </option>
      )
    })

    return(
      <div className='col-md-3 col-xs-12'>
        <select
          className='form-control'
          title='select certification'
          value={this.state.selectedTypeId}
          onChange={(e) => this.onChange(e)}
        >
          <option value=''>
            All Certifications
          </option>
          {certificationTypeOptions}
        </select>
      </div>
    )
  }
}

CertificationTypeSelect.propTypes = {
  certificationTypes: PropTypes.array
}

export default CertificationTypeSelect
